export default __webpack_public_path__ + "static/media/news.8ab078c1.svg";